<template>
  <div class="text-center foooter">
    <v-row>
      <v-col class="text-center px-0 mx-0">
        <v-btn :class="getClass(0)" @click="goTo(0)" depressed :icon="actual !== 0" :ripple="false" :small="!$vuetify.breakpoint.mdAndUp">
          <img
            src="@/assets/home-purple.png"
            style="
              max-height: 24px;
              min-height: 16px;
              height: 100%;
              max-width: 24px;
            "
          />

          <span class="ml-2" v-if="actual === 0"> Home </span>
        </v-btn>
      </v-col>
      <v-col class="text-center px-0 mx-0">
        <v-btn :class="getClass(2)" @click="goTo(2)" depressed :icon="actual !== 2" :ripple="false" :small="!$vuetify.breakpoint.mdAndUp">
          <img
            src="@/assets/idea-purple.png"
            style="
              max-height: 24px;
              min-height: 16px;
              height: 100%;
              max-width: 24px;
            "
          />

          <span class="ml-2" v-if="actual === 2 && !isConf"> Ideias </span>
        </v-btn>
      </v-col>
      <v-col class="text-center px-0 mx-0">
        <v-btn :class="getClass(1)" @click="goTo(1)" depressed :icon="actual !== 1" :ripple="false" :small="!$vuetify.breakpoint.mdAndUp">
          <img
            src="@/assets/zap-purple.png"
            style="
              max-height: 24px;
              min-height: 16px;
              height: 100%;
              max-width: 24px;
            "
          />

          <span class="ml-2" v-if="actual === 1 && !isConf"> Ações </span>
        </v-btn>
      </v-col>
      <v-col class="text-center px-0 mx-0">
        <v-btn :class="getClass(3)" @click="goTo(3)" depressed :icon="actual !== 3" :ripple="false" :small="!$vuetify.breakpoint.mdAndUp">
          <img
            src="@/assets/map-purple.png"
            style="
              max-height: 24px;
              min-height: 16px;
              height: 100%;
              max-width: 24px;
            "
          />

          <span class="ml-2" v-if="actual === 3 && !isConf"> Jornada </span>
        </v-btn>
      </v-col>
      <v-col class="text-center px-0 mx-0">
        <v-btn :class="getClass(5)" @click="openConf()" depressed :icon="actual !== 5" :ripple="false" v-if="footer" :small="!$vuetify.breakpoint.mdAndUp">
          <v-icon>mdi-cog-outline</v-icon>
          <span class="ml-2" v-if="this.isConf"> Config. </span>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    footer: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(['option', 'mobileRouter']),
  },
  data: () => ({
    route: false,
    actual: 0,
    visible: false,
    on: false,
    started: false,
    menu: ['/', '/acoes', '/ideias', '/jornada', '/salvos', '/perfil'],
    conf: {
      text: 'Configurações',
      icon: 'mdi-cog-outline',
      menu: [
        {
          text: 'Regras e Regulamento',
          icon: 'book-purple.png',
          route: '/',
        },
        {
          text: 'Sobre Nós',
          icon: 'book-open-purple.png',
          route: '/page/sobre',
        },
      ],
    },
    isConf: false,
    prevent: false,
  }),
  methods: {
    preventLogoff() {
      this.prevent = true
      this.$store.dispatch('setErrorInfo', {
        open: true,
        text: 'Tem certeza que deseja sair?',
        button: [{ text: 'Sair' }, { text: 'Não', outlined: true }],
      })
    },
    logoff() {
      localStorage.removeItem('user')
      window.location = '//www.unisinos.br/conecta'
    },
    getClass(item) {
      if ((item === this.actual && !this.isConf) || (this.actual === 5 && item === 5)) {
        return 'rounded-pill home-buttom color-purple font-dm mr-2'
      } else {
        return 'color-purple mr-2 disabled-menu'
      }
    },
    goTo(item) {
      this.check(this.menu[item], item)
    },
    openConf() {
      this.isConf = true
      this.actual = 5
      this.$store.dispatch('setMenuInfo', true)
    },
    openConf2() {
      this.isConf = true
      this.actual = 5
    },
    changeActualRoute() {
      const actualRoute = this.mobileRouter
      if (actualRoute === '/perfil' || actualRoute === '/salvos') {
        this.isConf = true
        this.actual = 5
        return
      }
      for (let i = 0; i < this.menu.length; i++) {
        const element = this.menu[i]
        if (element === actualRoute) {
          this.actual = i
        }
      }
    },
    openTutorial() {
      this.$store.dispatch('setErrorInfo', {
        open: true,
        text: 'Vamos reativar as dicas que vão lhe apresentar algumas funcionalidades da nossa plataforma.',
        button: 'Beleza, reativar!',
      })
      this.$store.dispatch('setResetInfo', true)
    },
    check(el, item) {
      this.route = el
      const profile = localStorage.getItem('salveProfile')
      if (profile) {
        this.$store.dispatch('setErrorInfo', {
          open: true,
          text: 'Deseja salvar as alterações?',
          button: [{ text: 'Salvar' }, { text: 'Cancelar', outlined: true }],
        })
      } else {
        if (el !== this.$route.path) {
          this.isConf = false
          this.actual = item
          this.$store.dispatch('setMenuInfo', false)
          this.$router.push(el)
        }
      }
    },
  },
  mounted() {
    this.changeActualRoute()
  },
  watch: {
    option() {
      if (this.prevent) {
        if (this.option === 0) {
          this.logoff()
          this.prevent = false
        }
        if (this.option === 1) {
          this.prevent = false
        }
      }
    },
    mobileRouter() {
      this.changeActualRoute()
    },
  },
}
</script>

<style>
.cogHover {
  display: none !important;
}

.cogDisHover {
  display: inline-block;
}

.menu:hover .cogHover {
  display: inline-block !important;
}

.menu:hover .cogDisHover {
  display: none;
}

.foooter {
  position: relative;
}

.disabled-menu {
  /* opacity: 30% !important; */
}

.menu {
  position: relative;
  display: inline-block;
}

.submenu {
  display: none;
  position: absolute;
  left: 0;
}

.menu:hover .submenu {
  display: block;
}
</style>
